import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { AppFilter } from "../../../models/app-filter.model";
import { AbAgendaAreaComum } from "app/abstract/full-pages/agendamento/agenda-area-comum.abstract";
import { CriadorAgendamento } from "app/models/criador-agendamento.model";
import { Pageable } from "app/models/pageable-mode";

@Injectable({ providedIn: 'root' })
export class AgendaAreaComumService extends AbAgendaAreaComum {

  public getAllAreaComum(): Observable<any> {
    return this.get(`agendamentos_areas_comuns/all`);
  }

  public createUpdateAgendaAreaComum(agenda) {
    if (agenda.id) {
      return this.save('agendamentos_areas_comuns/update/', agenda);
    } else {
      return this.save('agendamentos_areas_comuns/create/', agenda);
    }
  }

  public mediar(agenda) {
    return this.save('agendamentos_areas_comuns/mediar/', agenda);
  }

  public getAgendamentosByAreaEntreDatas(filter: AppFilter): Observable<any> {
    return this.get(`agendamentos_areas_comuns/area_comum/periodo/${filter.encode()}`);
  }

  public getAgendamentosAbertosById(id): Observable<any> {
    return this.get(`agendamentos_areas_comuns/area_comum/abertos/${id}`);
  }

  public getAgendaAreaComumById(id: number): Observable<any> {
    return this.get(`agendamentos_areas_comuns/agendamento_dto/`, id);
  }

  public cancelamentoDoAgendamento(id: number) {
    return this.delete('agendamentos_areas_comuns/', id);
  }

  public existeAgendamentoParaAprovar(): Observable<any> {
    return this.get(`agendamentos_areas_comuns/existe_agendamentos_aprovar`)
  }

  public getListarRelatorio(filter: string): Observable<any> {
    return this.get(`agendamentos_areas_comuns/relatorio/listar/${filter}`);
  }

  public getRelatorio(filter: string): Observable<any> {
    return this.get(`agendamentos_areas_comuns/relatorio/${filter}`);
  }

  public getCriadoresAgendamento(filter: AppFilter): Observable<Pageable<CriadorAgendamento>> {
    return this.get(`api/v1/agendamentos-areas-comuns/criadores/${filter.encode()}`);
  }
}
